export default {

  setSnackbar(state, { text, enabled }) {
    state.app.snackbar.text = text;
    state.app.snackbar.enabled = enabled;
  },
  clearSnackbar(state) {
    state.app.snackbar.text = "";
    state.app.snackbar.enabled = false;
  },
  

};
